import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import AdminNavbar from '../../components/admin/AdminNavbar';
import './AdminCommon.css';
import './AdminConfiguracion.css';

const AdminConfiguracion = () => {
  const queryClient = useQueryClient();
  const [editingKey, setEditingKey] = useState(null);
  const [editValue, setEditValue] = useState('');

  const { data: config = {}, isLoading } = useQuery({
    queryKey: ['configuracion'],
    queryFn: async () => {
      const response = await api.get('/configuracion');
      return response.data;
    }
  });

  const updateMutation = useMutation({
    mutationFn: async ({ clave, valor }) => {
      const response = await api.put(`/configuracion/${clave}`, { valor });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['configuracion']);
      setEditingKey(null);
      setEditValue('');
      alert('Configuración actualizada exitosamente');
    },
    onError: (error) => {
      alert('Error al actualizar configuración: ' + (error.response?.data?.error || error.message));
    }
  });

  const handleEdit = (clave, valor) => {
    setEditingKey(clave);
    setEditValue(valor || '');
  };

  const handleSave = (clave) => {
    updateMutation.mutate({ clave, valor: editValue });
  };

  const handleCancel = () => {
    setEditingKey(null);
    setEditValue('');
  };

  const configuraciones = [
    {
      clave: 'nombre_diocesis',
      label: 'Nombre de la Diócesis',
      descripcion: 'Nombre oficial del Diócesis de Ipiales'
    },
    {
      clave: 'direccion',
      label: 'Dirección',
      descripcion: 'Dirección física de la diócesis'
    },
    {
      clave: 'telefono',
      label: 'Teléfono',
      descripcion: 'Teléfono de contacto principal'
    },
    {
      clave: 'email',
      label: 'Correo Electrónico',
      descripcion: 'Email de contacto oficial'
    },
    {
      clave: 'horario_atencion',
      label: 'Horario de Atención',
      descripcion: 'Horarios de atención al público'
    },
    {
      clave: 'facebook_url',
      label: 'URL de Facebook',
      descripcion: 'URL de la página de Facebook de la diócesis'
    },
    {
      clave: 'instagram_url',
      label: 'URL de Instagram',
      descripcion: 'URL del perfil de Instagram de la diócesis'
    },
    {
      clave: 'twitter_url',
      label: 'URL de X (Twitter)',
      descripcion: 'URL del perfil de X (Twitter) de la diócesis'
    },
    {
      clave: 'youtube_url',
      label: 'URL de YouTube',
      descripcion: 'URL del canal de YouTube de la diócesis'
    },
    {
      clave: 'tiktok_url',
      label: 'URL de TikTok',
      descripcion: 'URL del perfil de TikTok de la diócesis'
    },
    {
      clave: 'tv_ipiales_embed_url',
      label: 'URL del reproductor TV Ipiales en vivo',
      descripcion: 'URL de embed del stream (iframe) para la página Medios. Debe ser la URL que proporciona el proveedor de streaming (ej. reproductor HLS o página de embed).'
    },
  ];

  if (isLoading) {
    return <div className="loading">Cargando configuración...</div>;
  }

  return (
    <div className="admin-configuracion">
      <AdminNavbar title="Configuración del Sitio" />
      <div className="admin-content-wrapper">
        <div className="container">
          <p className="section-description" style={{ marginBottom: '1.5rem' }}>
            La campaña de donaciones (título, imagen, cuenta bancaria, texto del botón) se configura en <Link to="/admin/donaciones">Donaciones</Link>.
          </p>

          <div className="config-list">
            <h2>Configuraciones del Sitio</h2>
            
            <div className="config-items">
              {configuraciones.map((item) => (
                <div key={item.clave} className="config-item">
                  <div className="config-label">
                    <label>{item.label}</label>
                    <p className="config-desc">{item.descripcion}</p>
                  </div>
                  
                  <div className="config-value">
                    {editingKey === item.clave ? (
                      <div className="config-edit">
                        <input
                          type="text"
                          value={editValue}
                          onChange={(e) => setEditValue(e.target.value)}
                          className="config-input"
                          autoFocus
                        />
                        <div className="config-actions">
                          <button
                            onClick={() => handleSave(item.clave)}
                            className="btn btn-sm btn-primary"
                            disabled={updateMutation.isLoading}
                          >
                            Guardar
                          </button>
                          <button
                            onClick={handleCancel}
                            className="btn btn-sm btn-secondary"
                          >
                            Cancelar
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="config-display">
                        <span className="config-text">
                          {config[item.clave] || 'No configurado'}
                        </span>
                        <button
                          onClick={() => handleEdit(item.clave, config[item.clave])}
                          className="btn btn-sm btn-edit"
                        >
                          Editar
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminConfiguracion;
